export interface BettingTabClickedEventProperties {
  tabName: string
}

export enum BettingScreens {
  BETTING = 'Betting',
}
